import script from "./ErrorToast.vue?vue&type=script&setup=true&lang=js"
export * from "./ErrorToast.vue?vue&type=script&setup=true&lang=js"

import "./ErrorToast.vue?vue&type=style&index=0&id=72fab633&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72fab633"]])

export default __exports__